import { Field, TextOutput } from 'Components/Core';
import { withInjectedProps } from 'Components/Core/InjectedPropsContext';
import { ListFieldSection } from 'Components/Layout';
import { IWorksheetComponent } from 'Components/Worksheets/Core/types';
import React from 'react';

let HydrometerWashResultsSection: React.FC<IWorksheetComponent> = () => (
  <ListFieldSection>
    <Field input={<TextOutput />} name="Masses.WashedDryMass" />
    <Field input={<TextOutput />} name="Masses.WashingsDryMass" />
    <Field input={<TextOutput />} name="Results.PercentRetainedWashingSieve" />
    <Field input={<TextOutput />} name="Results.PercentPassingWashingSieve" />
  </ListFieldSection>
);

HydrometerWashResultsSection = withInjectedProps(HydrometerWashResultsSection);

export default HydrometerWashResultsSection;
export { HydrometerWashResultsSection as ResultsSection };
